import React, { useState, useRef, useEffect } from "react"
import styled, { css } from "styled-components"

import { mediaDown } from "styles/media"

import One from "videos/1.mp4"
import Two from "videos/2.mp4"
import Three from "videos/3.mp4"
import Four from "videos/4.mp4"
import FourPlus from "videos/4+.mp4"
import Five from "videos/5.mp4"
import Six from "videos/6.mp4"
import Seven from "videos/7.mp4"
import Eight from "videos/8.mp4"
import Nine from "videos/9.mp4"
import Ten from "videos/10.mp4"
import Eleven from "videos/11.mp4"
import Twelve from "videos/12.mp4"
import Thirteen from "videos/13.mp4"
import Fourteen from "videos/14.mp4"
import Fifteen from "videos/15.mp4"
import Sixteen from "videos/16.mp4"
import Seventeen from "videos/17.mp4"
import Eighteen from "videos/18.mp4"
import Nineteen from "videos/19.mp4"
import Twenty from "videos/20.mp4"
import TwentyOne from "videos/21.mp4"
import TwentyTwo from "videos/22.mp4"
import TwentyThree from "videos/23.mp4"
import TwentyFour from "videos/24.mp4"
import TwentyFive from "videos/25.mp4"

const videos = [
  One,
  Two,
  Three,
  Four,
  FourPlus,
  Five,
  Six,
  Seven,
  Eight,
  Nine,
  Ten,
  Eleven,
  Twelve,
  Thirteen,
  Fourteen,
  Fifteen,
  Sixteen,
  Seventeen,
  Eighteen,
  Nineteen,
  Twenty,
  TwentyOne,
  TwentyTwo,
  TwentyThree,
  TwentyFour,
  TwentyFive
]

const Container = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100vh;
  overflow: hidden;

  ${mediaDown.small`
    display: none;
  `}
`

const VideoContainer = styled.video`
  min-width: 100%;
  min-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: -2;

  ${props =>
    props.active &&
    css`
      z-index: -1;
    `}
`

const playbackRate = 1

const Video = () => {
  const [index, setIndex] = useState(null)
  const [firstVideoActive, setFirstVideoActive] = useState(true)
  const [secondVideoActive, setSecondVideoActive] = useState(false)
  const videoRef = useRef()
  const secondVideoRef = useRef()

  useEffect(() => {
    let random = Math.floor(Math.random() * videos.length) + 0
    setIndex(random)
  }, [])

  useEffect(() => {
    // setIndex(Math.floor(Math.random() * videos.length) + 0)
    if (videoRef.current && secondVideoRef.current) {
      let currentIndex = index
      secondVideoRef.current.playbackRate = playbackRate
      videoRef.current.playbackRate = playbackRate
      const nextIndex = getNextIndex({
        currentIndex,
        maxIndex: videos.length - 1
      })
      const source = secondVideoRef.current.getElementsByTagName("source")[0]
      source.setAttribute("src", videos[nextIndex])
      secondVideoRef.current.load()
      currentIndex = nextIndex
      videoRef.current.play()

      videoRef.current.addEventListener("ended", () => {
        const nextIndex = getNextIndex({
          currentIndex,
          maxIndex: videos.length - 1
        })
        const source = videoRef.current.getElementsByTagName("source")[0]
        source.setAttribute("src", videos[nextIndex])
        videoRef.current.load()
        secondVideoRef.current.playbackRate = playbackRate
        secondVideoRef.current.play()
        setFirstVideoActive(false)
        setSecondVideoActive(true)
        currentIndex = nextIndex
      })

      secondVideoRef.current.addEventListener("ended", () => {
        const nextIndex = getNextIndex({
          currentIndex,
          maxIndex: videos.length - 1
        })
        const source = secondVideoRef.current.getElementsByTagName("source")[0]
        source.setAttribute("src", videos[nextIndex])
        secondVideoRef.current.load()
        videoRef.current.playbackRate = playbackRate
        videoRef.current.play()
        setFirstVideoActive(true)
        setSecondVideoActive(false)
        currentIndex = nextIndex
      })

      return () => {
        videoRef.current.removeEventListener("ended", () => {
          console.log("remove")
        })
      }
    }
  }, [index, videoRef, secondVideoRef])

  if (index !== 0 && !index) return null

  return (
    <Container>
      <VideoContainer
        playsinline
        active={firstVideoActive}
        muted
        ref={videoRef}
      >
        <source src={videos[index]} type="video/mp4" />
      </VideoContainer>
      <VideoContainer
        playsinline
        active={secondVideoActive}
        muted
        ref={secondVideoRef}
      >
        <source src={videos[index]} type="video/mp4" />
      </VideoContainer>
    </Container>
  )
}

export default Video

export const getNextIndex = ({ currentIndex, maxIndex }) => {
  if (currentIndex + 1 > maxIndex) {
    return 0
  } else {
    return currentIndex + 1
  }
}
